<template>
  <div class="contentArea">
    <AgGrid />
  </div>
</template>

<script>
import AgGrid from "@/views/elements/ag-grid-table/AgGridTable.vue";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      nowSlug: "getNowSlug",
      tabActive: "general/tab",
      page: "general/page",
      pointer: "general/pointer"
    })
  },

  components: {
    AgGrid
  },

  async mounted() {
    await this.$store.dispatch(
      "general/getCurriculumDetail",
      this.$route.params.id
    );

    this.$store.dispatch("general/push_pointer", "course");
  },

  updated() {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
